import { render, staticRenderFns } from "./GoalItemSheetContainer.vue?vue&type=template&id=2bb4d33c&"
import script from "./GoalItemSheetContainer.vue?vue&type=script&lang=js&"
export * from "./GoalItemSheetContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports